/* Homepage-only discount previews. Never changes the customer's cart or checkout. */
(function () {
  'use strict';
  if (window.LPHomeCardPrices) return;
  window.LPHomeCardPrices = true;
  var selector = '.lpq__card > [data-lpq-home-price]';
  var receiptKey = 'lpHomeCardDiscountCodes';
  var legacyKey = 'lpHalloween2026Claim';
  var claimedCodes = null;
  var latestCart = null;
  var timer;
  var revision = 0;
  var running = false;
  var pending = false;
  var preview = null;
  var cache = new Map();
  var submittedForms = new Set();
  var rewardReceipts = new WeakMap();

  var fields = 'id discountCodes { code applicable } lines(first: 2) { nodes { ' +
    'id quantity merchandise { ... on ProductVariant { id } } ' +
    'cost { subtotalAmount { amount currencyCode } } ' +
    'discountAllocations(lineLevelOnly: false) { discountedAmount { amount currencyCode } ' +
    '... on CartCodeDiscountAllocation { code } } } }';
  var payload = '{ cart { ' + fields + ' } userErrors { code field message } warnings { code message } }';
  var createQuery = 'mutation HomePriceCreate($input: CartInput!, $country: CountryCode!) ' +
    '@inContext(country: $country) { cartCreate(input: $input) ' + payload + ' }';
  var codesQuery = 'mutation HomePriceCodes($cartId: ID!, $codes: [String!]!, $country: CountryCode!) ' +
    '@inContext(country: $country) { cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $codes) ' + payload + ' }';
  var linesQuery = 'mutation HomePriceLine($cartId: ID!, $lines: [CartLineUpdateInput!]!, $country: CountryCode!) ' +
    '@inContext(country: $country) { cartLinesUpdate(cartId: $cartId, lines: $lines) ' + payload + ' }';

  function normalize(values) {
    if (!Array.isArray(values)) values = [values];
    return Array.from(new Set(values.filter(function (value) { return typeof value === 'string'; })
      .map(function (value) { return value.trim(); })
      .filter(function (value) { return value.length > 0 && value.length <= 255 && !/[\u0000-\u001f]/.test(value); }))).slice(0, 250);
  }

  function readCodes() {
    if (claimedCodes !== null) return claimedCodes;
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(receiptKey) || 'null');
      if (saved && Array.isArray(saved.codes)) return normalize(saved.codes);
    } catch (error) { /* Continue with the existing offer receipt. */ }
    if (latestCart) {
      var applied = cartCodes(latestCart);
      if (applied.length) return applied;
    }
    try {
      var legacy = JSON.parse(window.localStorage.getItem(legacyKey) || 'null');
      if (legacy && legacy.code) return normalize(legacy.code);
    } catch (error) { /* Storage is optional. */ }
    return [];
  }

  function remember(values) {
    var codes = normalize(values);
    if (!codes.length) return;
    claimedCodes = codes;
    try { window.sessionStorage.setItem(receiptKey, JSON.stringify({ codes: codes })); } catch (error) {}
    schedule();
  }

  function codesFromUrl(value) {
    try {
      var url = new URL(value, window.location.href);
      if (url.origin !== window.location.origin) return [];
      var path = url.pathname.match(/\/discount\/([^/]+)/);
      return normalize((path ? decodeURIComponent(path[1]) : url.searchParams.get('discount') || '').split(','));
    } catch (error) { return []; }
  }

  function rewardCodes(scope) {
    var codes = [];
    scope.querySelectorAll('input[aria-label*="discount" i], input[aria-label*="coupon" i], input[id*="coupon" i], [data-discount-code], [id*="discount-code"], [id*="coupon-code"], [class*="discount-code"], [class*="coupon-code"], [data-testid*="discount-code"]').forEach(function (node) {
      // Read visible reward codes, never an email or hidden reward template.
      if (!node.getClientRects().length) return;
      var value = node.getAttribute('data-discount-code') || node.value || node.textContent.trim();
      if (value && !/\s/.test(value)) codes.push(value);
    });
    scope.querySelectorAll('a[href]').forEach(function (node) {
      if (node.getClientRects().length) codes = codes.concat(codesFromUrl(node.href));
    });
    return normalize(codes);
  }

  function inspectRewards() {
    document.querySelectorAll('[data-newsletter-discount-success]').forEach(function (reward) {
      var input = reward.querySelector('input');
      if (input && input.value) {
        var codes = normalize(input.value);
        var signature = JSON.stringify(codes);
        if (rewardReceipts.get(reward) !== signature) {
          rewardReceipts.set(reward, signature);
          remember(codes);
        }
      }
    });
    submittedForms.forEach(function (id) {
      document.querySelectorAll('[id^="omnisend-form-"]').forEach(function (scope) {
        if (scope.id.indexOf(id) === -1) return;
        var codes = rewardCodes(scope);
        var signature = JSON.stringify(codes);
        if (codes.length && rewardReceipts.get(scope) !== signature) {
          rewardReceipts.set(scope, signature);
          remember(codes);
        }
      });
    });
  }

  function paint(card, current) {
    var base = Number(card.dataset.lpqPrice);
    if (!Number.isSafeInteger(base) || base < 0) return;
    if (!Number.isSafeInteger(current) || current < 0 || current > base) current = base;
    var reduced = current < base && !!window.LPMoney;
    var original = card.querySelector('[data-lpq-original]');
    var saving = card.querySelector('[data-lpq-saving]');
    if (window.LPMoney) {
      var options = { currency: card.dataset.lpqCurrency, locale: document.documentElement.lang || 'en' };
      card.querySelector('[data-lpq-current]').textContent = window.LPMoney.format(current, options);
      original.textContent = reduced ? window.LPMoney.format(base, options) : '';
      card.querySelector('[data-lpq-saving-amount]').textContent = reduced ? window.LPMoney.format(base - current, options) : '';
    }
    original.hidden = !reduced;
    saving.hidden = !reduced;
  }

  function priceFromPreview(card, cart, codes) {
    var base = Number(card.dataset.lpqPrice);
    var wanted = codes.map(function (code) { return code.toUpperCase(); });
    var applicable = (cart.discountCodes || []).filter(function (entry) {
      return entry.applicable && wanted.indexOf(entry.code.toUpperCase()) !== -1;
    });
    var lines = cart.lines && cart.lines.nodes || [];
    if (!applicable.length || lines.length !== 1) return base;
    var line = lines[0];
    var subtotal = line.cost && line.cost.subtotalAmount;
    if (line.quantity !== 1 || !line.merchandise ||
        line.merchandise.id !== 'gid://shopify/ProductVariant/' + card.dataset.lpqVariantId ||
        !subtotal || subtotal.currencyCode !== card.dataset.lpqCurrency ||
        Math.round(Number(subtotal.amount) * 100) !== base) return base;
    var allocations = line.discountAllocations || [];
    var hasCodeReduction = allocations.some(function (allocation) {
      return allocation.code && applicable.some(function (entry) {
        return entry.code.toUpperCase() === allocation.code.toUpperCase();
      }) && Number(allocation.discountedAmount.amount) > 0;
    });
    if (!hasCodeReduction) return base;
    // Include order-level allocations. Shopify decides fixed amounts,
    // eligibility, caps and combination rules; no percentage is hardcoded.
    var discount = 0;
    for (var allocation of allocations) {
      var money = allocation.discountedAmount;
      if (!money || money.currencyCode !== card.dataset.lpqCurrency ||
          !Number.isFinite(Number(money.amount)) || Number(money.amount) < 0) return base;
      discount += Math.round(Number(money.amount) * 100);
    }
    return Math.max(0, base - discount);
  }

  async function storefront(query, variables, operation) {
    // Omit cookies: this Storefront cart is independent of the Online Store
    // cart. Its ID is held only in this adapter's memory.
    var response = await fetch('/api/2026-10/graphql.json', {
      method: 'POST', credentials: 'omit', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query: query, variables: variables })
    });
    if (!response.ok) throw new Error('Preview unavailable');
    var result = await response.json();
    var output = result.data && result.data[operation];
    if (result.errors || !output || output.userErrors && output.userErrors.length || !output.cart) {
      var failure = new Error('Preview unavailable');
      failure.variantUnavailable = !!(output && output.userErrors && output.userErrors.some(function (error) {
        return /MERCHANDISE|SOLD_OUT|QUANTITY|PRODUCT/.test(error.code || '') ||
          (error.field || []).indexOf('lines') !== -1;
      }));
      throw failure;
    }
    var nodes = output.cart.lines && output.cart.lines.nodes || [];
    if (nodes.length !== 1 || !nodes[0].id || nodes[0].quantity !== 1 || !nodes[0].merchandise) {
      var transformed = new Error('Unexpected preview lines');
      transformed.variantUnavailable = true;
      throw transformed;
    }
    preview = { id: output.cart.id, lineId: nodes[0].id, country: variables.country,
      variant: nodes[0].merchandise.id, codes: variables.codes || variables.input && variables.input.discountCodes || preview && preview.codes };
    return output.cart;
  }

  async function quote(card, codes) {
    var country = card.dataset.lpqCountry;
    if (!/^[A-Z]{2}$/.test(country || '')) throw new Error('Missing market');
    var variant = 'gid://shopify/ProductVariant/' + card.dataset.lpqVariantId;
    var cart;
    if (!preview || preview.country !== country) {
      cart = await storefront(createQuery, { country: country, input: {
        buyerIdentity: { countryCode: country }, discountCodes: codes,
        lines: [{ merchandiseId: variant, quantity: 1 }]
      } }, 'cartCreate');
    } else {
      if (JSON.stringify(preview.codes) !== JSON.stringify(codes)) {
        cart = await storefront(codesQuery, { country: country, cartId: preview.id, codes: codes }, 'cartDiscountCodesUpdate');
      }
      if (preview.variant !== variant || !cart) {
        cart = await storefront(linesQuery, { country: country, cartId: preview.id,
          lines: [{ id: preview.lineId, merchandiseId: variant, quantity: 1, attributes: [] }]
        }, 'cartLinesUpdate');
      }
    }
    return priceFromPreview(card, cart, codes);
  }

  function cartCodes(cart) {
    var codes = (cart.discount_codes || []).filter(function (entry) { return entry.applicable !== false; })
      .map(function (entry) { return entry.code; });
    (cart.cart_level_discount_applications || []).forEach(function (application) {
      if (application.type === 'discount_code') codes.push(application.title);
    });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        var application = allocation.discount_application;
        if (application && application.type === 'discount_code') codes.push(application.title);
      });
    });
    return normalize(codes);
  }

  async function refresh() {
    var cards = Array.from(document.querySelectorAll(selector));
    if (!cards.length) return;
    if (running) { pending = true; return; }
    running = true;
    pending = false;
    var request = revision;
    try {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      var response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      latestCart = response.ok ? await response.json() : null;
    } catch (error) { latestCart = null; }
    var codes = readCodes();
    if (!codes.length && latestCart) codes = cartCodes(latestCart);
    for (var card of cards) {
      if (request !== revision) break;
      var base = Number(card.dataset.lpqPrice);
      if (!codes.length) { paint(card, base); continue; }
      var key = JSON.stringify([codes, card.dataset.lpqCountry, card.dataset.lpqCurrency, card.dataset.lpqVariantId, base]);
      var entry = cache.get(key);
      if (entry && Date.now() - entry.time < 60000) { paint(card, entry.price); continue; }
      try {
        var price = await quote(card, codes);
        if (request === revision) {
          cache.set(key, { price: price, time: Date.now() });
          paint(card, price);
        }
      } catch (error) {
        preview = null;
        if (request === revision) paint(card, base);
        if (error.variantUnavailable) continue;
        // Do not retry a failed API once per product in the same refresh.
        break;
      }
    }
    running = false;
    if (pending || request !== revision) schedule();
  }

  function schedule() {
    revision++;
    clearTimeout(timer);
    document.querySelectorAll(selector).forEach(function (card) { paint(card, Number(card.dataset.lpqPrice)); });
    timer = setTimeout(refresh, 100);
  }

  function bind() {
    var urlCodes = codesFromUrl(window.location.href);
    if (urlCodes.length) remember(urlCodes);
    inspectRewards();
    schedule();
    window.addEventListener('lpHalloweenClaimed', function () {
      try {
        var receipt = JSON.parse(window.localStorage.getItem(legacyKey) || 'null');
        if (receipt && receipt.code) remember(receipt.code);
      } catch (error) {}
      inspectRewards();
      schedule();
    });
    window.addEventListener('lp:discount:claimed', function (event) {
      var detail = event.detail || {};
      remember(detail.codes || detail.code);
    });
    window.addEventListener('omnisendForms', function (event) {
      var detail = event.detail || {};
      if ((detail.type || detail.eventName) === 'submit' && detail.form && detail.formValues && detail.formValues.emailField) {
        submittedForms.add(String(detail.form.id));
        inspectRewards();
        schedule();
      }
    });
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (link) {
        var codes = codesFromUrl(link.href);
        if (codes.length) remember(codes);
      }
    });
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-cart-drawer-discount-form]');
      if (form && form.elements.discount) remember(form.elements.discount.value);
    });
    window.addEventListener('storage', function (event) {
      if (event.key === legacyKey || event.key === receiptKey || event.key === null) {
        claimedCodes = null;
        schedule();
      }
    });
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () { inspectRewards(); }).observe(document.body, {
        childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'hidden', 'value']
      });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    document.addEventListener('shopify:section:load', function () { inspectRewards(); schedule(); });
    window.addEventListener('pageshow', schedule);
    window.addEventListener('focus', schedule);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') schedule(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
})();
